import { Lock, FileEdit } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { PeriodStatus } from '@/types/period'

interface PeriodStatusBadgeProps {
  status: PeriodStatus | null
  className?: string
}

/**
 * Badge component to display period lock status
 * Shows icon + text with color coding
 */
export function PeriodStatusBadge({ status, className }: PeriodStatusBadgeProps) {
  if (!status || status === 'draft') {
    return (
      <Badge variant="secondary" className={className}>
        <FileEdit className="w-3 h-3 mr-1" />
        Pågående arbete
      </Badge>
    )
  }

  if (status === 'locked') {
    return (
      <Badge variant="destructive" className={className}>
        <Lock className="w-3 h-3 mr-1" />
        Låst
      </Badge>
    )
  }

  return null
}
